import React from "react";
import { useRoutes } from "react-router-dom";
import routers from "./router";
import "@/style/font-awesome/css/font-awesome.css";
import "@/assets/fonts/iconfont.css";
import "@arco-design/web-react/dist/css/arco.css";
import "@/style/globals.less";

const App: React.FC = () => {
  const element = useRoutes(routers);
  return <>{element}</>;
};
export default App;
